/**
 * app打开过程中产生的全局数据
 * 解决跨住这儿中跨webview 信息同步
 */

const LOCALSTORAGE_IN_SESSION_KEY = 'LOCALSTORAGE_IN_SESSION_KEY';

interface ISessionData {
  couponModalHasShow?: boolean; // 优惠券弹窗已弹窗
  homeBannerModalHasShow?: boolean; // 首页广告是否已经弹窗
}

interface IRawStorageData {
  [p: string]: ISessionData;
}

export default class LocalStorageInSession {
  static sessionId = '';

  static init(sessionId: string) {
    LocalStorageInSession.sessionId = sessionId;

    const data = LocalStorageInSession.getSessionData();
    // 检测会话数据是否过期清空历史会话数据，设置新的会话数据
    if (!data) {
      localStorage.removeItem(LOCALSTORAGE_IN_SESSION_KEY);
      sessionStorage.removeItem(LOCALSTORAGE_IN_SESSION_KEY);
      LocalStorageInSession.updateLocalStorage({
        couponModalHasShow: false,
        homeBannerModalHasShow: false,
      });
    }
  }

  static getSessionData = () => {
    let localData: IRawStorageData = {};
    let sessionData: ISessionData = {};

    try {
      localData = JSON.parse(
        localStorage.getItem(LOCALSTORAGE_IN_SESSION_KEY) || '{}',
      );
    } catch (ex) {
      localData = {};
    }

    try {
      sessionData = JSON.parse(
        sessionStorage.getItem(LOCALSTORAGE_IN_SESSION_KEY) || '{}',
      );
    } catch (ex) {
      sessionData = {};
    }
    return localData[LocalStorageInSession.sessionId] || sessionData;
  };

  static updateLocalStorage = (data: ISessionData) => {
    const sessionData = LocalStorageInSession.getSessionData();
    localStorage.setItem(
      LOCALSTORAGE_IN_SESSION_KEY,
      JSON.stringify({
        [LocalStorageInSession.sessionId]: { ...(sessionData || {}), ...data },
      }),
    );

    // session 会话信息中的不需要前缀，以免后退时被新 sessionId 覆盖
    sessionStorage.setItem(
      LOCALSTORAGE_IN_SESSION_KEY,
      JSON.stringify({
        ...(sessionData || {}),
        ...data,
      }),
    );
  };

  /**
   * 增加优惠券弹窗次数
   */
  static setCouponModalHasShow = () => {
    LocalStorageInSession.updateLocalStorage({
      couponModalHasShow: true,
    });
  };

  /**
   * 首页广告是否已经弹窗
   */
  static setHomeBannerModalHasShow = () => {
    LocalStorageInSession.updateLocalStorage({
      homeBannerModalHasShow: true,
    });
  };

  /**
   * 获取指定数据
   */
  static getData = (key: keyof ISessionData) => {
    const data = LocalStorageInSession.getSessionData();
    return data?.[key];
  };
}
